export const OPEN_PASSWORD_CHANGE_MODAL = 'OPEN_PASSWORD_CHANGE_MODAL';
export const CLOSE_PASSWORD_CHANGE_MODAL = 'CLOSE_PASSWORD_CHANGE_MODAL';
export const FAILED_PASSWORD_CHANGE_MODAL = 'FAILED_PASSWORD_CHANGE_MODAL';

function openPasswordChangeModal() {
  return {
    type: OPEN_PASSWORD_CHANGE_MODAL,
    isPasswordChangeModalShown: true
  };
}

function closePasswordChangeModal() {
  return {
    type: CLOSE_PASSWORD_CHANGE_MODAL,
    isPasswordChangeModalShown: false,
    changePasswordError: null
  };
}

function failedPasswordChangeModal(changePasswordError) {
  return {
    type: FAILED_PASSWORD_CHANGE_MODAL,
    isPasswordChangeModalShown: true,
    changePasswordError
  };
}

function closeFailedPasswordChangeModal() {
  return {
    type: FAILED_PASSWORD_CHANGE_MODAL,
    isPasswordChangeModalShown: true,
    changePasswordError: null
  };
}

export function showPasswordChangeModal() {
  return (dispatch) => {
    dispatch(openPasswordChangeModal());
  };
}

export function hidePasswordChangeModal() {
  return (dispatch) => {
    dispatch(closePasswordChangeModal());
  };
}

export function showFailedPasswordChangeModal(changePasswordError) {
  return (dispatch) => {
    dispatch(failedPasswordChangeModal(changePasswordError));
  };
}

export function closeFailedPasswordChangeModalError() {
  return (dispatch) => {
    dispatch(closeFailedPasswordChangeModal());
  };
}
